// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/schuko-clamp/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchukoClampEN: PageEntry = {
  id: "example.produkte-schuko-klammer",
  locale: "en",
  slug: "produkte/schuko-clamp",
  seo: {
    title: "Schuko Clamp | Dietz GmbH",
    description: "Use in state-of-the-art and modular socket systems for the smart home sector. Use of alloys that are cheaper than the non-ferrous metals used as standard – without sacrificing qual",
  },
  type: "post",
  h1: "Schuko Clamp",
  intro: "Use in state-of-the-art and modular socket systems for the smart home sector. Use of alloys that are cheaper than the non-ferrous metals used as standard – without sacrificing quality.",
  blocks: [
    { kind: "image", src: "/images/live/prod_stanz-umformtechnik.jpg", alt: "Schuko Clamp", width: 1280, height: 1024 }
  ],
};
